import * as React from "react";
import { AddAddress } from "./AddAddress";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { PhysicalAddressType } from "../../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { AddressDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/AddressDetailModel";
import { FullClientDetailHelper } from "../../../Common/FullClientDetail/FullClientDetailHelper";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";

interface IAddAddressesProps extends IProcessComponentProps {
    onCCMChange: (changes) => void;
    data: FullClientDetailModel;
    canChooseCountry: boolean;
    onCorrespondenceAddressChange: (changes) => void;
}

interface IAddAddressesState {
    UseAddressForCorrespondence?: boolean;
}

export class AddAddresses extends ProcessComponent<IAddAddressesProps, IAddAddressesState> {
    constructor(props: any) {
        super(props);
        this.state = {
            UseAddressForCorrespondence: null,
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.updateUseAddressForCorrespondence();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (
            prevProps.data?.ActorId !== this.props.data?.ActorId ||
            prevProps.data?.AddressDetails.length !== this.props.data?.AddressDetails.length
        ) {
            this.updateUseAddressForCorrespondence();
        }
    }

    private updateUseAddressForCorrespondence() {
        if (this.props.data.AddressDetails?.length > 0) {
            const isSameCorrespondenceAddress = this.isSameCorrespondenceAddress(this.props.data.AddressDetails);
            this.setState({
                UseAddressForCorrespondence: isSameCorrespondenceAddress,
            });
            this.props.onCorrespondenceAddressChange(isSameCorrespondenceAddress);
        }
    }

    private isSameCorrespondenceAddress(addressDetails: AddressDetailModel[]): boolean {
        if (addressDetails.length < 2) {
            return true;
        }
        const postalAddress = addressDetails?.find((ele) => ele.PhysicalAddressType == PhysicalAddressType.Postal);
        const residentialAddress = addressDetails?.find(
            (ele) => ele.PhysicalAddressType == PhysicalAddressType.Residential
        );

        const isSameCorrespondenceAddress =
            !CommonHelper.isNullOrEmpty(postalAddress) &&
            !CommonHelper.isNullOrEmpty(residentialAddress) &&
            FullClientDetailHelper.isSameAddress(postalAddress?.Address, residentialAddress?.Address);

        return isSameCorrespondenceAddress;
    }

    private resetUseAddressForCorrespondence() {
        const data = this.props.data.AddressDetails;
        const index = data?.findIndex((ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential);

        const postalindex = index == 1 ? 0 : 1;
        data.splice(postalindex, 1);
        this.props.onCCMChange([{ value: data, path: `AddressDetails` }]);
        this.setState({
            UseAddressForCorrespondence: false,
        });
        this.props.onCorrespondenceAddressChange(false);
    }

    private hasResident(): boolean {
        return this.props.data.AddressDetails?.some(
            (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
        );
    }

    validAddress(address: AddressDetailModel): boolean {
        return (
            address?.Address?.Address1 != null &&
            address?.Address?.Address1 != "" &&
            address?.Address?.Country != null &&
            address?.Address?.PostCode != null &&
            address?.Address?.PostCode != ""
        );
    }

    private setPostalAddress = (v: boolean) => {
        const postalAddress = FullClientDetailHelper.setPostalAddress(v, this.props.data);
        this.props.onCCMChange(postalAddress);
    };

    render() {
        const { data } = this.props;
        const { UseAddressForCorrespondence } = this.state;
        return (
            <>
                <AddAddress
                    label="Residential address"
                    canChooseCountry={this.props.canChooseCountry}
                    onAddressChange={(v) => this.props.onChange({ Address: v })}
                    address={data.AddressDetails?.find(
                        (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                    )}
                    index={
                        data?.AddressDetails == null || data.AddressDetails?.length == 0
                            ? 0
                            : !this.hasResident()
                            ? 1
                            : data.AddressDetails?.findIndex(
                                  (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                              )
                    }
                    disabled={false}
                    onCCMChange={(changes) => {
                        this.props.onCCMChange(changes);
                    }}
                    addressType={PhysicalAddressType.Residential}
                    addressList={data.AddressDetails}
                    resetUseAddressForCorrespondence={() => this.resetUseAddressForCorrespondence()}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={() => {}}
                    data={null}
                />

                {data.AddressDetails && this.hasResident() && (
                    <>
                        <RadiosEditor
                            cssWrapper="rg-inline mb-16"
                            selected={UseAddressForCorrespondence}
                            label={"Use this address for all correspondence"}
                            options={[true, false]}
                            getText={(v) => (v ? "Yes" : "No")}
                            required={"Please select"}
                            onChange={(v) => {
                                this.setPostalAddress(v);
                                this.setState({ UseAddressForCorrespondence: v });
                                this.props.onCorrespondenceAddressChange(v);
                            }}
                        />
                        {this.state.UseAddressForCorrespondence == false && (
                            <AddAddress
                                label="Correspondence address"
                                onAddressChange={(v) => this.props.onChange({ CorrespondenceAddress: v })}
                                address={data.AddressDetails?.find(
                                    (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Postal
                                )}
                                canChooseCountry={false}
                                index={
                                    data.AddressDetails.findIndex(
                                        (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                                    ) == 0
                                        ? 1
                                        : 0
                                }
                                disabled={false}
                                onCCMChange={(changes) => {
                                    this.props.onCCMChange(changes);
                                }}
                                addressType={PhysicalAddressType.Postal}
                                addressList={data.AddressDetails}
                                onRef={(ref) => this.appendChild(ref)}
                                onChange={() => {}}
                                data={null}
                            />
                        )}
                    </>
                )}
            </>
        );
    }
}
